module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (84).b8cbb13b.jpg";